import jwt_decode from "jwt-decode";
import {
  HTTP_LOCAL_HOST_3000,
  HTTPS_LOCAL_HOST_3000,
} from "../constants/constants";

interface ACCESS_TOKEN {
  exp: number;
  iss: string;
  aud: string;
  client_id: string;
  sub: string;
  auth_time: number;
  idp: string;
  role: string;
  name: string;
  given_name: string;
  profile: string;
  jti: string;
  iat: number;
  scope: string[];
  amr: string[];
}

// Decode Token:
export const decodeToken = (token: any) => {
  const decodedJwt: ACCESS_TOKEN = jwt_decode(token);
  return decodedJwt;
};

// Get DealerId From Token
export const getDealerIdFromToken = (token: any) => {
  const decodedJwt = decodeToken(token);
  // Get the profile object from token:
  const profileObj = JSON.parse(decodedJwt.profile);
  const dealerId = profileObj.dealerId;
  return dealerId;
};

export const ALLOWED_PARENT_ORIGINS = [
  process.env.REACT_APP_Client_Login_Page_URL,
  process.env.REACT_APP_Client_Staging_Login_Page_URL,
  HTTP_LOCAL_HOST_3000,
  HTTPS_LOCAL_HOST_3000,
];

export const getBaseUrlWithoutLastPath = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    const segments = parsedUrl.pathname.split("/").filter(Boolean);

    if (segments.length > 0) {
      segments.pop(); // Remove the last segment
      parsedUrl.pathname = "/" + segments.join("/");
    } else {
      parsedUrl.pathname = "";
    }

    return parsedUrl.toString().replace(/\/$/, ""); // remove trailing slash
  } catch (err) {
    return "";
  }
};
